(function () {
  var DURATION_MS = 3500;

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function parseTickerValue(raw) {
    var s = (raw || '').trim();
    if (!s) return { target: 0, suffix: '' };
    var m = s.match(/-?[\d,]*\.?\d+/);
    if (!m) return { target: 0, suffix: s };
    var target = parseFloat(m[0].replace(/,/g, ''));
    if (Number.isNaN(target)) return { target: 0, suffix: s };
    var suffix = s.slice(m.index + m[0].length).trim();
    return { target: target, suffix: suffix };
  }

  function countDecimals(n) {
    var str = String(n);
    var i = str.indexOf('.');
    if (i === -1) return 0;
    return str.length - i - 1;
  }

  function formatAnimatedValue(value, target) {
    var places = countDecimals(target);
    if (places === 0) {
      return String(Math.round(value));
    }
    return value.toFixed(places);
  }

  function runTicker(root) {
    var valueEl = root.querySelector('[data-number-ticker-value]');
    var suffixEl = root.querySelector('[data-number-ticker-suffix]');
    if (!valueEl || !suffixEl) return;

    var parsed = parseTickerValue(root.getAttribute('data-value') || '');
    var target = parsed.target;
    var suffix = parsed.suffix;

    suffixEl.textContent = suffix;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      valueEl.textContent = formatAnimatedValue(target, target);
      return;
    }

    var from = 0;
    var startTime = null;

    function frame(now) {
      if (startTime === null) startTime = now;
      var elapsed = now - startTime;
      var t = Math.min(1, elapsed / DURATION_MS);
      var eased = easeInOutCubic(t);
      var current = from + (target - from) * eased;
      valueEl.textContent = formatAnimatedValue(current, target);
      if (t < 1) {
        requestAnimationFrame(frame);
      }
    }

    requestAnimationFrame(frame);
  }

  function init() {
    var nodes = document.querySelectorAll('[data-number-ticker]');
    if (!nodes.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          runTicker(el);
        });
      },
      { rootMargin: '0px 0px -5% 0px', threshold: 0.15 }
    );

    nodes.forEach(function (node) {
      if (reduced) {
        runTicker(node);
      } else {
        io.observe(node);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
